module.exports = __webpack_public_path__ + "img/Aggregation_Population.61aa1eca.png";